import { render, staticRenderFns } from "./TableOutputByCategories.vue?vue&type=template&id=5293c2d8"
import script from "./TableOutputByCategories.vue?vue&type=script&lang=js"
export * from "./TableOutputByCategories.vue?vue&type=script&lang=js"
import style0 from "./TableOutputByCategories.vue?vue&type=style&index=0&id=5293c2d8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports